import { renderIcon } from '../../utils';
export var wrapper = "rounded-10 p-4 relative";
export var innerWrapper = 'flex flex-row ';
export var extendedContentWrapper = 'pl-3 mt-2 ';
export var iconWrapper = 'flex-shrink-0';
export var contentWrapper = function (isOnlyTitle) {
    return "flex flex-col ".concat(isOnlyTitle ? 'justify-center' : 'justify-start', " items-start mr-auto");
};
export var icon = 'h-5 w-5 ';
export var messageWrapper = 'ml-3 ';
export var message = function (hasTitle) {
    return "text-sm font-normal ".concat(hasTitle && 'mt-2 ');
};
export var title = 'text-sm ';
export var list = 'list-disc pl-4 mt-2 ';
export var alertColor = function (type, style) {
    switch (type) {
        case 'infoDark':
            return "text-white ".concat(style !== 'flat' && 'border-infoDark', " bg-infoMain");
        case 'info':
            return "text-infoDark ".concat(style !== 'flat' && 'border-infoDark', " bg-infoBb");
        case 'success':
            return "text-successDark ".concat(style === 'flat'
                ? 'border-successDark bg-successBg'
                : 'border-successMain bg-successMain');
        case 'successLight':
            return "text-successDark ".concat(style === 'flat'
                ? 'border-successDark bg-successBg'
                : 'border-successMain bg-successMain');
        case 'warning':
            return "text-alertDark ".concat(style !== 'flat' && 'border-alertDark', " bg-alertBg");
        case 'error':
            return "text-errorDark ".concat(style !== 'flat' && 'border-errorDark', " bg-errorBg");
        case 'accent':
            return "text-secondary ".concat(style !== 'flat' && 'border-secondary', " bg-secondaryAccent2");
        default:
            return "text-infoDark ".concat(style !== 'flat' && 'border-infoDark', " bg-infoBb");
    }
};
export var alertTextColor = function (type, variant) {
    switch (type) {
        case 'infoDark':
            return 'white';
        case 'info':
            return 'infoDark';
        case 'success':
            return variant === 'outlined' ? 'white' : 'successDark';
        case 'successLight':
            return variant === 'outlined' ? 'white' : 'successDark';
        case 'warning':
            return 'alertDark';
        case 'error':
            return 'errorDark';
        case 'accent':
            return 'secondary';
        default:
            return 'infoDark';
    }
};
var getIcon = function (iconName, colorType, variant) {
    return renderIcon(iconName, icon + alertIconColor(colorType, variant));
};
export var alertIconColor = function (type, variant) {
    switch (type) {
        case 'successLight':
            return variant === 'outlined' ? 'text-white' : "text-successMain ";
        case 'infoDark':
            return "text-white";
        case 'info':
            return "text-infoMain";
        case 'success':
            return variant === 'outlined' ? 'text-white' : "text-successMain ";
        case 'warning':
            return "text-alertMain ";
        case 'error':
            return "text-errorMain ";
        case 'accent':
            return "text-secondary ";
        default:
            return "";
    }
};
export var alertIcon = function (type, variant) {
    switch (type) {
        case 'infoDark':
            return getIcon('InformationCircleIcon', 'infoDark');
        case 'info':
            return getIcon('InformationCircleIcon', 'info');
        case 'success':
            return getIcon('CheckCircleIcon', 'success', variant);
        case 'successLight':
            return getIcon('CheckCircleIcon', 'successLight', variant);
        case 'warning':
            return getIcon('ExclamationIcon', 'warning');
        case 'error':
            return getIcon('XCircleIcon', 'error');
        case 'accent':
            return getIcon('InformationCircleIcon', 'accent');
        default:
            return getIcon('information-circle', 'info');
    }
};
//# sourceMappingURL=alert.style.js.map